import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isAuthenticated: false,

      // LRA-specific state
      lraUser: null,
      lraRole: null,
      lraDetails: null,

      // Currently active portal: 'merchant' | 'lra'
      activeView: 'merchant',

      setAuth: (token, user) => {
        set({
          token,
          user,
          isAuthenticated: true,
        });
      },

      setLRAUser: (lraUser) => {
        set({
          lraUser,
          lraRole: lraUser?.role || null,
          lraDetails: lraUser?.details || null,
        });
      },

      clearLRAUser: () => {
        set({
          lraUser: null,
          lraRole: null,
          lraDetails: null,
          activeView: 'merchant',
        });
      },

      setActiveView: (view) => {
        if (view !== 'merchant' && view !== 'lra') return;
        set({ activeView: view });
      },

      // Role helper methods
      isMerchant: () => get().lraRole === 'merchant' || !get().lraRole,
      isOfficer: () => get().lraRole === 'officer',
      isAdmin: () => get().lraRole === 'admin',
      isAgent: () => get().lraRole === 'agent',
      hasLRAAccess: () => {
        const role = get().lraRole;
        return role === 'officer' || role === 'admin' || role === 'agent';
      },
      // True if the user could potentially see both portals
      isMultiRole: () => get().hasLRAAccess(),

      updateUser: (user) => set({ user }),

      logout: () => {
        set({
          token: null,
          user: null,
          isAuthenticated: false,
          lraUser: null,
          lraRole: null,
          lraDetails: null,
          activeView: 'merchant',
        });
      },

      getToken: () => get().token,
      getUser: () => get().user,
    }),
    {
      name: 'lra-auth-storage',
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        lraUser: state.lraUser,
        lraRole: state.lraRole,
        lraDetails: state.lraDetails,
        activeView: state.activeView,
      }),
    }
  )
);
